module.exports = __webpack_public_path__ + "static/img/inquiry_bg.432125b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_index/inquiry_bg.png
// module id = jqDW
// module chunks = 1